// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1-Ahs","overflowing":"ReadFullNote_overflowing__RhZq0"};